<div class="container">
  <div class="wrapper">
    <h1>About</h1>
    <p>
      This is a tool for finding deals on Amazon Resale. You can learn more
      about Amazon Resale
      <a
        target="_blank"
        href="https://www.amazon.com/Amazon-Resale/b?ie=UTF8&node=10158976011&tag=dealforager-20"
        >here</a
        >. Deals are updated several times a day.
      </p>
      <h2>Disclaimer</h2>
      <ul>
        @if (affiliateEnabled) {
          <li>
            As an Amazon Affiliate, I earn commissions from qualifying purchases.
          </li>
        }
        <li>
          Used item stock is usually low. If you don't see the used item on Amazon
          it means it was probably sold recently.
        </li>
        <li>Discounts are estimates and may be inaccurate.</li>
        <li>Prices change constantly so prices may be inaccurate.</li>
      </ul>
      <h2>Search Tips</h2>
      <ul>
        <li>
          Use fewer words. For example, instead searching for "gaming keyboard",
          you might get better results by just searching for "keyboard". Sometimes
          sellers don't include words too many words in their product titles.
        </li>
        <li>
          Search for similar items. For example if you are looking for
          "headphones", looking for "headset" might also yield some good results.
        </li>
        <li>
          Use the price and category filters to filter out results for popular
          keywords. For example, if you're looking for smartphones, make sure to
          set the price filter high enough that most of the accessories get
          filtered out to make it easier to browse.
        </li>
      </ul>
      <h2>Company</h2>
      <ul>
        <li>Contact: admin&#64;dealforager.com</li>
        <li>
          <a routerLink="/privacypolicy">Privacy Policy</a>
        </li>
      </ul>
    </div>
  </div>
